// deps
import React, { memo, ReactElement } from "react";

// components
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

//styles
import { Container, RedeemButton } from "./styles";

interface RedeemVoucherProps {
    labelText: string;
    btnText: string;
    onButtonClick?: VoidFunction;
}

function RedeemVoucher({ labelText, btnText, onButtonClick }: RedeemVoucherProps): ReactElement {
    return (
        <Container>
            <Text variant="V2.body2.neutral.bold" color="text_Med_Emphasis">
                {labelText}
            </Text>
            <RedeemButton buttonSize="small" color="special_positive" onClick={onButtonClick}>
                {btnText}
            </RedeemButton>
        </Container>
    );
}

export default memo(RedeemVoucher);
